import { memo, useCallback, useRef, useState } from "react";
import ScrollableTable from "src/components/shared/ScrollableTable/ScrollableTable";
import type { ISummaryItem } from "src/pages/Summary/Summary.types";

import type { IEntrySelectValue } from "../Multiple.model";
import EntriesSelectListItem from "./EntriesSelectListItem";

interface Props {
  items: ISummaryItem[];
  toggleCollapse?: (index: number) => void;
  entries?: Record<string, any>[][];
  setSelectedEntries: (selectedEntries: IEntrySelectValue[]) => void;
  selectedEntries: IEntrySelectValue[];
  loading: boolean;
}

const EntriesSelectList = ({
  items,
  toggleCollapse,
  entries,
  selectedEntries,
  setSelectedEntries,
  loading,
}: Props) => {
  const [focusedRowIndex, setFocusedRowIndex] = useState<number>(-1);
  const scrollableTableRef = useRef<HTMLDivElement>(null);

  const headers = [
    { label: "Show Entry" },
    { label: "Entry" },
    { label: "Opened" },
    { label: "Status" },
    { label: "Select" },
  ];
  if (!entries) {
    headers.splice(0, 1);
  }

  const renderRow = useCallback(
    ({ row, index }: { row: ISummaryItem; index?: number }) => {
      const sections =
        index !== undefined && entries && entries[index]
          ? entries[index]
          : undefined;
      return (
        index !== undefined && (
          <EntriesSelectListItem
            key={`entry-row-${index}`}
            index={index}
            sections={sections}
            {...row}
            toggleCollapse={toggleCollapse}
            selectedEntries={selectedEntries}
            setSelectedEntries={setSelectedEntries}
            isFocused={focusedRowIndex === index && false}
            setFocused={setFocusedRowIndex}
          />
        )
      );
    },
    [
      entries,
      toggleCollapse,
      selectedEntries,
      setSelectedEntries,
      focusedRowIndex,
    ],
  );

  return (
    <div style={{ width: "100%" }} ref={scrollableTableRef}>
      <ScrollableTable
        loading={loading}
        headers={headers}
        data={items}
        renderRow={renderRow}
        style={{
          maxHeight: entries ? "65vh" : "35vh",
          overflowY: "auto",
        }}
      />
    </div>
  );
};
export default memo(EntriesSelectList);
